import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { LocationSliceState } from "../../utils/location.types";
import { ApiStatus } from "../../utils/api.types";
import { fetchLocations, fetchLocationById, addLocation, updateLocation } from "./locationThunk";

const initialState: LocationSliceState = {
  locations: [],
  locationDetails: {},
  rowCount: 0,
  status: ApiStatus.IDLE,
  errorMessage: "",
  isLocationCreated: false,
  selectedLocationId: "",
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch list (endpoint returns a plain array)
      .addCase(fetchLocations.pending, (state) => {
        state.status = ApiStatus.LOADING;
      })
      .addCase(fetchLocations.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.locations = Array.isArray(action.payload) ? action.payload : action.payload?.locations || [];
        state.rowCount = state.locations.length;
        state.errorMessage = "";
      })
      .addCase(fetchLocations.rejected, (state, action) => {
        state.status = ApiStatus.FAILED;
        state.errorMessage = action.error.message;
      })

      // Fetch by id
      .addCase(fetchLocationById.pending, (state) => {
        state.status = ApiStatus.LOADING;
      })
      .addCase(fetchLocationById.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.locationDetails = action.payload || {};
        state.errorMessage = "";
      })
      .addCase(fetchLocationById.rejected, (state, action) => {
        state.status = ApiStatus.FAILED;
        state.errorMessage = action.error.message;
      })

      // Create
      .addCase(addLocation.pending, (state) => {
        state.status = ApiStatus.LOADING;
        state.isLocationCreated = false;
      })
      .addCase(addLocation.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.isLocationCreated = true;
        if (action.payload && action.payload._id) state.locations.push(action.payload);
        state.errorMessage = "";
        toast.success("Location created successfully");
      })
      .addCase(addLocation.rejected, (state, action) => {
        state.status = ApiStatus.FAILED;
        state.isLocationCreated = false;
        state.errorMessage = action.error.message;
        toast.error(action.error.message || "Failed to create location");
      })

      // Update
      .addCase(updateLocation.pending, (state) => {
        state.status = ApiStatus.LOADING;
      })
      .addCase(updateLocation.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.locationDetails = action.payload || {};
        state.errorMessage = "";
        toast.success("Location updated successfully");
      })
      .addCase(updateLocation.rejected, (state, action) => {
        state.status = ApiStatus.FAILED;
        state.errorMessage = action.error.message;
        toast.error(action.error.message || "Failed to update location");
      });
  },
});

export default locationSlice.reducer;
